export default {"src":"https://marketing-edge-assets.lemonade.com/_next/static/media/car.19f1c2c9.svg","height":245,"width":680,"blurWidth":0,"blurHeight":0};